import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { PermissionWithOptions } from './instancePermissionPanel.component';

export interface ICellRendererParamsForInstanceRightGridAction extends ICellRendererParams {
    canEdit: () => boolean;
    permissionChanged: () => void;
}

@Component({
    selector: 'instance-grid-action-cell',
    template: `
    @if (!params.canEdit()) {
      <span>{{params.data.right.rights}}</span>
    }
    @if (params.canEdit()) {
      <select class="form-select-sm"
        [(ngModel)]="params.data.right" (change)="params.permissionChanged()">
        @for (right of params.data.rightOptions; track right) {
          <option [ngValue]="right">{{right.rights}}</option>
        }
      </select>
    }
    `,
    standalone: false
})
export class InstanceRightGridActionCellRendererComponent implements ICellRendererAngularComp {
    params: ICellRendererParamsForInstanceRightGridAction;
    rightOptions: PermissionWithOptions[];
    right: PermissionWithOptions;

    agInit(params: ICellRendererParamsForInstanceRightGridAction): void {
        this.params = params;
    }

    refresh(): boolean {
        return false; // tells grid to handle refreshing
    }
}
